import { useApi } from 'ApiHooks'
import ModalConfirmarAnularLote from 'Components/ModalConfirmarAnularLote'
import { useBlockUI } from 'Context/BlockUIContext'
import { useErrorModal } from 'Context/ErrorModalContext'
import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, ProgressBar } from 'react-bootstrap'
import Loader from 'react-loaders'

export interface ModalVistaPreviaPDFProps {
  showModalVistaArchivo: boolean
  handleCloseModalVisualizarArchivo: () => void
  progress?: number
  base64Archivo?: string
  nombreArchivo?: string
  nroLotePDF?: number
  anularLoteButton?: boolean
}

const ModalVistaPreviaPDF = ({
  showModalVistaArchivo,
  base64Archivo,
  handleCloseModalVisualizarArchivo,
  progress,
  nroLotePDF,
  nombreArchivo = 'archivo.pdf',
  anularLoteButton = true
}: ModalVistaPreviaPDFProps) => {

  const api = useApi()
  const { showBlock, hideBlock, blocking } = useBlockUI()
  const { showError } = useErrorModal()
  const [pdfUrl, setPdfUrl] = useState<string>('')
  const [showModalAnularLote, setShowModalAnularLote] = useState<boolean>(false)

  const base64ToBlob = (base64: string) => {
    const byteCharacters = atob(base64)
    const byteNumbers = new Uint8Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    return new Blob([byteNumbers], { type: 'application/pdf' })
  }

  const anularLote = async () => {
    showBlock("Anulando lote...")
    try {
      const response = await api.anularLote({
        nroLote: nroLotePDF!,
        hash: ''
      })
      if (!response?.error) {
        setShowModalAnularLote(false)
        handleCloseModalVisualizarArchivo()
      }
    } catch (error: any) {
      if (!api.isCancel(error)) {
        showError({
          title: 'Error al cargar datos',
          message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
        })
      }
    } finally {
      hideBlock()
    }
  }

  const descargarPDF = () => {
    if (!pdfUrl) return

    const link = document.createElement('a')
    link.href = pdfUrl
    link.download = nombreArchivo
    link.click()
  }

  const abrirEnNuevaVentana = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank')
    }
  }

  useEffect(() => {
    if (base64Archivo) {
      const blob = base64ToBlob(base64Archivo)
      const url = URL.createObjectURL(blob)
      setPdfUrl(url)

      return () => URL.revokeObjectURL(url)
    }
  }, [base64Archivo])
  return (

    <>
      <Modal
        animation={false}
        backdrop="static"
        show={showModalVistaArchivo}
        onHide={handleCloseModalVisualizarArchivo}
        centered
        size="xl"
      >
        <Modal.Header>
          <Modal.Title style={{ color: 'white' }}>Vista previa PDF</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Col className="d-flex flex-column align-items-center">

            {progress === 0 && (
              <>
                <p className="fw-bold">Obteniendo archivo...</p>
                <Loader active={blocking} type="ball-beat" />
              </>
            )}

            {!base64Archivo && progress !== undefined && (
              <ProgressBar
                style={{ width: 300, height: 25 }}
                striped
                now={progress}
                label={`${progress}%`}
              />
            )}

            {pdfUrl && (
              <object
                data={pdfUrl}
                type="application/pdf"
                width="100%"
                height="600px"
                aria-label="Vista previa PDF"
                style={{ border: '1px solid #ccc', marginTop: 15 }}
              />
            )}
            <div className="mt-3">
              <div className="row g-2">
                {pdfUrl && (
                  <>
                    <div className="col-12 col-md-auto">
                      <Button
                        className="w-100"
                        variant="primary"
                        onClick={abrirEnNuevaVentana}
                      >
                        Abrir en nueva ventana
                      </Button>
                    </div>

                    <div className="col-12 col-md-auto">
                      <Button
                        className="w-100"
                        variant="success"
                        onClick={descargarPDF}
                      >
                        Descargar PDF
                      </Button>
                    </div>

                    {anularLoteButton && <div className="col-12 col-md-auto">
                      <Button
                        className="w-100"
                        variant="warning"
                        onClick={() => setShowModalAnularLote(true)}
                      >
                        Anular Lote
                      </Button>
                    </div>}
                  </>
                )}

                <div className="col-12 col-md-auto">
                  <Button
                    className="w-100"
                    variant="danger"
                    onClick={handleCloseModalVisualizarArchivo}
                  >
                    Cerrar
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Modal.Body>
      </Modal>

      <ModalConfirmarAnularLote
        setShow={setShowModalAnularLote}
        show={showModalAnularLote}
        anularLote={anularLote}
      />
    </>
  )
}

export default ModalVistaPreviaPDF
